import type { JSX } from 'react';

import { Typography } from '@mui/material';
import { AppSuiteTenant } from 'common/types/Entities';

export const displayTenantOptionMenuItemContent = (option: AppSuiteTenant): JSX.Element => {
    return (
        <Typography>
            {option.name}
        </Typography>
    );
};
